
export let timeLineVisibilityMap: Map<string, boolean> = new Map();
export let visibleTimeLine: boolean =false;

export function getLayerName(layerName: string, isVisible:boolean) {
    if(layerName==="wind"){
      timeLineVisibilityMap.set(layerName, isVisible);
      timeLineVisibilityMap.set("temperature", false);
      timeLineVisibilityMap.set("rain", false);
      timeLineVisibilityMap.set("airPressure", false);
    }else if(layerName==="temperature"){
      timeLineVisibilityMap.set(layerName, isVisible);
      timeLineVisibilityMap.set("wind", false);
      timeLineVisibilityMap.set("rain", false);

      
      timeLineVisibilityMap.set("airPressure", false);
    }else if(layerName==="rain"){
      timeLineVisibilityMap.set(layerName, isVisible);
      timeLineVisibilityMap.set("wind", false);
      timeLineVisibilityMap.set("temperature", false);
     timeLineVisibilityMap.set("airPressure", false);
    }else if(layerName==="airPressure"){
      timeLineVisibilityMap.set(layerName, isVisible);
      timeLineVisibilityMap.set("wind", false);
      timeLineVisibilityMap.set("temperature", false);
     timeLineVisibilityMap.set("rain", false);
    }else{
      timeLineVisibilityMap.set(layerName, isVisible);
    }

    visibleTimeLine = Array.from(timeLineVisibilityMap.values()).some(value => value === true);

  }